<template>
    <header class="page-hero d-flex align-start mb-8 flex-wrap" style="gap:16px">
        <div class="page-hero__text mr-auto" style="min-width:0">
            <eyebrow
                v-if="eyebrow"
                strong
                class="mb-3"
            >
                {{ eyebrow }}
            </eyebrow>
            <h1 class="hero-title mb-2">
                <slot name="title">{{ resolvedTitle }}</slot>
            </h1>
            <p
                v-if="$slots.subtitle || resolvedSubtitle"
                class="body-sm"
                style="max-width:640px"
            >
                <slot name="subtitle">{{ resolvedSubtitle }}</slot>
            </p>
        </div>

        <div
            v-if="$slots.actions"
            class="page-hero__actions d-flex align-center"
            style="gap:8px;flex-shrink:0"
        >
            <slot name="actions" />
        </div>
    </header>
</template>

<script>
export default {
    name: 'PageHero',
    props: {
        title: {
            type: String,
            default: null,
        },
        subtitle: {
            type: String,
            default: null,
        },
        eyebrow: {
            type: String,
            default: null,
        },
        useStore: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        resolvedTitle() {
            if (this.title) return this.title
            if (this.useStore) return this.$store.state.pageTitle || this.$route.meta.title || this.$route.name
            return ''
        },
        resolvedSubtitle() {
            if (this.subtitle) return this.subtitle
            if (this.useStore) return this.$store.state.pageSubtitle
            return ''
        },
    },
}
</script>
